import * as types from '../actions/actionTypes'


const mySubmittedPointsReducer = (state = {
    allMySubmittedPoints: [],
    currentTotal: 0,
    runningTotal: 0,
    bonusLevelRank: -1,
}, action) => {

    switch(action.type) {
      case types.GET_MY_SUBMITTED_POINTS_SUCCESS: 

      state = {
        ...state,
        currentTotal: action.payload.currentTotal,
        runningTotal: action.payload.runningTotal,
        bonusLevelRank: action.payload.bonusLevelRank,
        allMySubmittedPoints: action.payload.salesPoints,
      };
      break;

      case types.MY_SUBMITTED_POINTS_POINT_DELETE:
        const deleteSelectedMySubmittedPointsPoints = state.allMySubmittedPoints
          
        const resultDelete = deleteSelectedMySubmittedPointsPoints.filter(pointObject => pointObject.nodeName != action.payload);
        state = {
          ...state,
          allMySubmittedPoints: resultDelete
        };
      break;

      case types.SET_CURRENT_COMPANY: 
        //if logging in with a different company wipe all of the store 
      state = {
        ...state,
        allMySubmittedPoints: action.payloadTwo ? state.allMySubmittedPoints : [],
        currentTotal: action.payloadTwo ? state.currentTotal : [],
        runningTotal: action.payloadTwo ? state.runningTotal : [],
        bonusLevelRank: action.payloadTwo ? state.bonusLevelRank : []
      };
      break;

      default:
      break;    
    }

    return state;
};


export default mySubmittedPointsReducer;



// WEBPACK FOOTER //
// ./src/reducers/mySubmittedPointsReducer.js